import React, { useEffect } from "react";
import useAuth from './hooks/useAuth';
import './Loginbutton.css';
import { Link} from 'react-router-dom';
import { useGoogleOneTapLogin } from '@react-oauth/google';
//import axios from 'axios';
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import axios from './api/axios';
const LOGIN_URL = process.env.REACT_APP_LOGIN_API_URL + "/google-auth/api/v1/token";
const LOGIN_KEY_URL = process.env.REACT_APP_LOGIN_API_URL + "/api/v2/api-token";
function LoginButton(props) {   
    const { setAuth } = useAuth();
    let navigate = useNavigate();
    useEffect(() => {
    }, [])

    const handleCallbackResponse = async (e) => {
        try {
            const response = await axios.post(LOGIN_URL,
                '',
                {
                    headers: { 'Content-Type': 'application/json', 'x-token-type': 'One-tap', "x-token": e.credential, 'Access-Control-Allow-Origin': process.env.REACT_APP_DATA_API_URL,},

                }
            );
            const keyResponse = await axios.get(LOGIN_KEY_URL,
                {
                    headers: { 'Content-Type': 'application/json', "Authorization": 'Bearer '.concat(response?.data?.access_token) },

                }
            );
            //console.log(JSON.stringify(response));
            const email = response?.data?.user?.email
            const user = response?.data?.user?.first_name + " " + response?.data?.user?.last_name;
            const accessToken = response?.data?.access_token;
            const refreshToken = response?.data?.refresh_token;
            const key = keyResponse?.data?.token;
            const itemsData = { user, key, accessToken, refreshToken, email }
            localStorage.setItem('NKUserProfileInfo', JSON.stringify(itemsData))
            setAuth({ user, key, accessToken, refreshToken, email});
            navigate("/");
        } catch (err) { 
            console.log(err)
            /*if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 400) {
                setErrMsg('Missing Username or Password'); 
            } else if (err.response?.status === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }*/
        }
    }

    useGoogleOneTapLogin({
        onError: error => console.log(error),
        onSuccess: response => handleCallbackResponse(response),
        googleAccountConfigs: {
            client_id: "293375405749-i8qhl8aujplmiapclijjv0ffqob8enr4.apps.googleusercontent.com"
        },
    })



    return (
        <Link className="LoginButton" key="Login_Button" style={{marginBottom:"5px"}}>
            <div className="Login" onClick={props.onClick}>
                LOGIN
            </div>
            
        </Link>
    );
}

export default LoginButton;